import axios from "axios";

const api = axios.create({
    baseURL: 'https://airmont.crmside.fr/api'
  });



export default api;